import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Step3 = ({ pendingFiles, setPendingFiles, S }) => {
  const { t } = useTranslation();
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const addFiles = fileList => {
    const arr = Array.from(fileList);
    setPendingFiles(prev => {
      const existingNames = new Set(prev.map(f => f.name));
      return [...prev, ...arr.filter(f => !existingNames.has(f.name))];
    });
  };

  const removeFile = name => setPendingFiles(prev => prev.filter(f => f.name !== name));

  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.claimsScreen.new.step3Title')}</div>
      <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 24 }}>{t('screens.claimsScreen.new.step3Desc')}</div>
      <input
        ref={fileInputRef}
        type='file'
        multiple
        accept='.pdf,.doc,.docx,.xlsx,.xls,.jpg,.jpeg,.png'
        style={{ display: 'none' }}
        onChange={e => {
          addFiles(e.target.files);
          e.target.value = '';
        }}
      />
      <div
        onClick={() => fileInputRef.current?.click()}
        onDragOver={e => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={e => {
          e.preventDefault();
          setDragOver(false);
          addFiles(e.dataTransfer.files);
        }}
        style={{
          border: `2px dashed ${dragOver ? S.burgundy : S.borderLight}`,
          borderRadius: 14,
          padding: '48px 20px',
          textAlign: 'center',
          cursor: 'pointer',
          background: dragOver ? 'rgba(128,0,32,0.03)' : 'transparent',
          transition: 'all 0.2s',
        }}
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 24 24'
          fill='none'
          stroke={dragOver ? S.burgundy : '#94a3b8'}
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
          <polyline points='17 8 12 3 7 8' />
          <line x1='12' y1='3' x2='12' y2='15' />
        </svg>
        <div style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary, marginTop: 12 }}>{t('screens.claimsScreen.detail.dropDocuments')}</div>
        <div style={{ fontSize: 12, color: S.textMuted, marginTop: 4 }}>{t('screens.claimsScreen.detail.docsUploadHint')}</div>
      </div>
      {pendingFiles.length > 0 && (
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {pendingFiles.map(f => (
            <div
              key={f.name}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '10px 14px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 10,
              }}
            >
              <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke={S.burgundy} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
                <polyline points='14 2 14 8 20 8' />
              </svg>
              <span style={{ flex: 1, fontSize: 13, color: S.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
              <span style={{ fontSize: 12, color: S.textMuted }}>{(f.size / 1024).toFixed(0)} KB</span>
              <button
                onClick={() => removeFile(f.name)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: '2px 6px', fontSize: 16, lineHeight: 1 }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
      <div style={{ fontSize: 12, color: S.textMuted, marginTop: 16, textAlign: 'center' }}>{t('screens.claimsScreen.new.docsAutoClassified')}</div>
    </div>
  );
};

export default Step3;
